import { UserRoles } from "../../../types/userRoles";

export interface SettingsTabsInterface {
  id: number;
  title: string;
  path: string;
  roles: string[];
}

export const SettingsTabs: SettingsTabsInterface[] = [
  {
    id: 1,
    title: "SIDE_MENU.SETTINGS_LIST.PROFILE",
    path: "/settings/profile",
    roles: [
      UserRoles.SUPER_ADMIN,
      UserRoles.COORDINATOR,
      UserRoles.EDITOR,
      UserRoles.AUDITOR,
      UserRoles.CONTRIBUTOR,
      UserRoles.SUPER_USER,
    ],
  },
  {
    id: 2,
    title: "SIDE_MENU.SETTINGS_LIST.WORKSPACE",
    path: "/settings/workspace-management",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 3,
    title: "SIDE_MENU.SETTINGS_LIST.DATA_EXCHANGE",
    path: "/settings/data-exchange",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 4,
    title: "SIDE_MENU.SETTINGS_LIST.ROLE_MANAGEMENT",
    path: "/settings/role-management",
    roles: [UserRoles.SUPER_ADMIN],
  },
  {
    id: 5,
    title: "SIDE_MENU.SETTINGS_LIST.RISK_LEVEL_MANAGEMENT",
    path: "/settings/risk-level-management",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 6,
    title: "SIDE_MENU.SETTINGS_LIST.QUESTIONS_BUILDER",
    path: "/settings/questions-builder",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 7,
    title: "SIDE_MENU.SETTINGS_LIST.DATABASE_VALUE_MANAGEMENT",
    path: "/settings/database-value-management",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 8,
    title: "SIDE_MENU.SETTINGS_LIST.BRANCH_MANAGEMENT",
    path: "/settings/branch-management",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
  {
    id: 9,
    title: "SIDE_MENU.SETTINGS_LIST.ACTIVITY_LOG",
    path: "/settings/activity-log",
    roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
  },
];
